module.exports = __webpack_public_path__ + "static/media/11.1cce90f4.png";